import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://lhhgosbcwbdrhvywykio.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxoaGdvc2Jjd2Jkcmh2eXd5a2lvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE1MzUzOTUsImV4cCI6MjA2NzExMTM5NX0.eSGSwQio-InxWKHT38li9r9K34-nsMALCo6dCzCxgjM'

if(SUPABASE_URL === 'https://<PROJECT-ID>.supabase.co' || SUPABASE_ANON_KEY === '<ANON_KEY>') {
  throw new Error('Missing Supabase variables');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce'
  }
})

// Test connection
console.log('Supabase: Connected')

export default supabase